import {
  FETCH_VM_SETTINGS,
  RESET_VM_SETTINGS,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const vmSettingsView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM_SETTINGS:
      return { data: action.payload, others: action.others };
    case RESET_VM_SETTINGS:
      return initialState;
    default:
      return state;
  }
};

export default vmSettingsView;
